<template>
  <v-card>
    <v-card-title>
        Editar uma versão
    </v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formVersao">
        <v-layout row wrap fill-height justify-space-between>
            <v-flex xs5>
                <v-text-field
                  label="Versão"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosVersao.versao"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field
                  label="Data da versão"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  type="date"
                  v-model="dadosVersao.data_versao"
                  required
                >
                </v-text-field>
            </v-flex>
        </v-layout>
            <v-layout row wrap align-center>
                Qual aplicação:
                <v-spacer></v-spacer>
                <v-radio-group
                  row
                  v-model="aplicacaoGroup"
                  :rules="[(v) => !!v || 'Selecione uma aplicação']"
                  required
                >
                  <v-radio
                    color="primary"
                    label="App Clientes"
                    value="cliente"
                  ></v-radio>
                  <v-radio
                    color="primary"
                    label="App Postos"
                    value="posto"
                  ></v-radio>
                </v-radio-group>
            </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-textarea
                    v-model="dadosVersao.descricao"
                    counter="500"
                    label="Descrição"
                    required
                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                >
                </v-textarea>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="info" @click="atualizarVersao()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  data () {
    return {
      valid: false,
      aplicacaoGroup: null,
      dadosVersao: {
        descricao: null,
        versao: null,
        data_versao: null,
        app_cliente: false,
        app_posto: false
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    versao () {
      return this.$store.getters.versao
    }
  },
  mounted () {
    if (this.versao) {
      this.dadosVersao.descricao = this.versao.descricao
      this.dadosVersao.versao = this.versao.versao
      this.dadosVersao.data_versao = this.versao.data_versao
      this.dadosVersao.app_cliente = this.versao.app_cliente
      this.dadosVersao.app_posto = this.versao.app_posto
      if (this.versao.app_cliente) {
        this.aplicacaoGroup = 'cliente'
      } else if (this.versao.app_posto) {
        this.aplicacaoGroup = 'posto'
      }
    }
  },
  watch: {
    aplicacaoGroup (val) {
      if (val === 'cliente') {
        this.dadosVersao.app_cliente = true
        this.dadosVersao.app_posto = false
      } else if (val === 'posto') {
        this.dadosVersao.app_posto = true
        this.dadosVersao.app_cliente = false
      }
    },
    versao (val) {
      if (val) {
        this.dadosVersao.descricao = val.descricao
        this.dadosVersao.versao = val.versao
        this.dadosVersao.data_versao = val.data_versao
        this.dadosVersao.app_cliente = val.app_cliente
        this.dadosVersao.app_posto = val.app_posto
        if (val.app_cliente) {
          this.aplicacaoGroup = 'cliente'
        } else if (val.app_posto) {
          this.aplicacaoGroup = 'posto'
        }
      }
    }
  },
  methods: {
    fechar () {
      this.$refs.formVersao.reset()
      this.$store.dispatch('selectVersao', null)
      this.$emit('fechar')
    },
    atualizarVersao () {
      if (this.$refs.formVersao.validate()) {
        this.$store.dispatch('atualizarVersao', { ...this.dadosVersao, id_versao: this.versao.id_versao }).then(response => {
          this.$emit('info', 'Versão atualizada com sucesso')
          this.fechar()
        }).catch(() => {
          this.$emit('error', 'Não foi possível atualizar a versão')
          this.fechar()
        })
      }
    }
  }
}
</script>
